let toastFunction;

export const ToastMsgInit = (toastFn) => {
  toastFunction = toastFn;
};

const ToastMsg = (type, messageText) => {
  if (!toastFunction) {
    console.warn("ToastMsg not initialized. Wrap your app with ToastProvider.");
    return;
  }
  toastFunction(type, messageText);
};

export default ToastMsg;
